import React from "react";
import InformacaoCategoriaAnimal from "./InformacaoCategoriaAnimal";
import CardDetalhesFarol from "features/manejo/views/components/cardDetalhesFarol";
import { useTranslations } from "adapters/i18n";

export const DetalhesCategorias = (props) => {
  const { categorias, pastosRetiroComLotes, curraisRetiroComLotes } = props;
  const { t } = useTranslations();
  return (
    <CardDetalhesFarol id="detalhesCategorias" tituloCard={t("animalCategory:category")}>
      {categorias.map((categoria) => (
        <InformacaoCategoriaAnimal
          key={`${categoria.IdCategoriaAnimal}-categoria`}
          pastos={pastosRetiroComLotes}
          categoria={categoria}
          curraisRetiroComLotes={curraisRetiroComLotes}
        />
      ))}
    </CardDetalhesFarol>
  );
};

export default DetalhesCategorias;
